import { trackError } from '@billy/track-error'
import { useMutation } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../enums/queryKeys'
import { confirmCerfaLinkOnSign } from '../query-api'

interface UseConfirmCerfaLinkOnSignOptions {
  onError?: () => void
  onSuccess?: () => void
}

export const useConfirmCerfaLinkOnSign = ({ onError, onSuccess }: UseConfirmCerfaLinkOnSignOptions) => {
  const { organization } = useUserOrganization()
  const network = 'PDP'

  const { mutateAsync, isLoading } = useMutation(
    [QueryKeys.EInvoicingConfirmCerfaLinkOnSign, network, organization?.id],
    (signatureRequestId: string) => {
      if (!organization?.id) {
        const errorMessage = 'Organization ID is required to confirm Cerfa link on sign'
        trackError(errorMessage)
        return Promise.reject(new Error(errorMessage))
      }
      return confirmCerfaLinkOnSign({ network, signatureRequestId, targetId: organization.id })
    },
    {
      onError,
      onSuccess,
    },
  )

  return {
    confirmCerfaLinkOnSign: mutateAsync,
    isProcessing: isLoading,
  }
}
